import { render, staticRenderFns } from "./DetailBox.vue?vue&type=template&id=693aa714&scoped=true&"
import script from "./DetailBox.vue?vue&type=script&lang=js&"
export * from "./DetailBox.vue?vue&type=script&lang=js&"
import style0 from "./DetailBox.vue?vue&type=style&index=0&id=693aa714&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693aa714",
  null
  
)

export default component.exports